const isBlogPost = (post: unknown): post is BlogPost => {
	return typeof post === 'object' && post !== null && 'metadata' in post && 'default' in post;
};

const pathsToPosts = (
	paths: Record<string, BlogPost>,
	filter: ((post: BlogPostMetadata) => boolean) | null
) => {
	const posts: BlogPostMetadata[] = [];

	for (const path in paths) {
		const post = paths[path];
		if (!isBlogPost(post)) continue;
		const slug = path.split('/').at(-2)?.replace('.md', '');
		if (slug) {
			const meta = post.metadata as Omit<BlogPostMetadata, 'slug'>;
			const newPost = { ...meta, slug };

			if (!filter || filter(newPost)) {
				posts.push(newPost);
			}
		}
	}

	return posts;
};

/**
 * Fetches all posts and returns them as their proper type.
 */
export const getPosts = () => {
	const paths = import.meta.glob('/src/routes/posts/**/*.md', {
		eager: true
	}) satisfies Record<string, BlogPost>;
	const posts = pathsToPosts(paths, null);

	return posts;
};

/**
 * Fetches all posts that match one or more of a given tag
 * and returns them as their proper type.
 */
export const getPostsByTag = (...tags: string[]) => {
	const paths = import.meta.glob('/src/routes/posts/**/*.md', {
		eager: true
	}) satisfies Record<string, BlogPost>;

	const posts = pathsToPosts(paths, (post) => post.tags?.some((tag) => tags.includes(tag)));

	return posts;
};

/**
 * Fetches and returns a single post by its slug. (eg. /posts/Hello-World, slug = Hello-World)
 */
export const getSinglePost = async (slug: string) => {
	const post = await import(`../../../posts/${decodeURIComponent(slug)}/post.md`);
	if (!isBlogPost(post)) {
		throw new Error(`Post not found: ${slug}`);
	}
	return post;
};
